<div id="location-detail-wrapper" data-cy="location-detail-wrapper">
  <p *ngIf="notFound" data-cy="location-not-found">Location not found.</p>

  <ep-location-form-card
    *ngIf="location && !notFound"
    [title]="location.Name"
    [mode]="(mode$ | async)!"
    [isSaving]="isSaving"
    [isSaveDisabled]="(isSaveDisabled$ | async) === true"
    (edit)="edit()"
    (cancel)="cancelEdit()"
    (save)="saveLocation()"
  >
    <app-location-form></app-location-form>
  </ep-location-form-card>
</div>
